// removed by extract-text-webpack-plugin
module.exports = {"toolbarWrapper":"style__toolbarWrapper___2OIaH","searchBtn":"style__searchBtn___m9uAj","searchIcon":"style__searchIcon___1Y_e1"};


//////////////////
// WEBPACK FOOTER
// ./components/Toolbar/style.scss
// module id = ./components/Toolbar/style.scss
// module chunks = 5